import React, {useEffect, useState} from 'react'
import {getClients} from './requests'
import {ModeleClient, ModeleClientContact} from './Models'

interface SearchClientProps {
  placeholder?: string
  setClient: (client: ModeleClient | undefined | null) => void
  initialClient?: ModeleClient | undefined | null
  contactClient?: ModeleClientContact | undefined | null
  disabled?: boolean
}

const SearchClient: React.FC<SearchClientProps> = ({placeholder, setClient, initialClient, contactClient, disabled}) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [filteredClients, setFilteredClients] = useState<ModeleClient[]>([])
  const [loading, setLoading] = useState(false)
  const [showResults, setShowResults] = useState(false)

  useEffect(() => {
    if (searchTerm.length === 0) {
      setFilteredClients([])
      setClient(null)
      return
    }

    if (searchTerm.length < 3) {
      setFilteredClients([])
      return
    }

    const timer = setTimeout(() => {
      setLoading(true)
      getClients(1, searchTerm, '', '')
        .then((res) => {
          setFilteredClients(res.data ?? [])
        })
        .finally(() => setLoading(false))
    }, 400)

    return () => clearTimeout(timer)
  }, [searchTerm])

  useEffect(() => {
    if (initialClient || contactClient) {
      let searchFormat = ""
      if(initialClient?.nom || initialClient?.prenom){
        searchFormat = `${initialClient?.nom} ${initialClient?.prenom}`
      }else{
        if(initialClient?.nomSociete){
          searchFormat =`${initialClient?.nomSociete}`
        }else{
          if(contactClient !== null && contactClient !== undefined) {
            searchFormat = `${contactClient?.nom} ${contactClient?.prenom}`
          }else{
            searchFormat = initialClient?.telephone ? `${initialClient?.telephone}` : `${initialClient?.mobile}`
          }
        }
      }
      setSearchTerm(searchFormat)
      setClient(initialClient)
    }
  }, [initialClient, contactClient])

  const handleSelect = (client: ModeleClient) => {
    setClient(client)
    setShowResults(false)
    let libelleClient = ""
    if(client?.nom || client?.prenom){
      libelleClient = `${client?.nom} ${client.prenom}`
    }else{
      if(client?.nomSociete){
        libelleClient = `${client?.nomSociete}`
      }else{
        libelleClient = client?.telephone ? `${client?.telephone}` : `${client?.mobile}`
      }
    }
    setSearchTerm(libelleClient)
  }

  return (
    <div className='position-relative'>
      <input
        type='text'
        className='form-control'
        placeholder={placeholder ?? 'Rechercher...'}
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value)
          setShowResults(true)
        }}
        autoComplete='off'
        disabled={disabled}
      />

      {showResults && searchTerm && (
        <div
          className='border bg-white position-absolute w-100 shadow-sm mt-1'
          style={{zIndex: 1000, maxHeight: 250, overflowY: 'auto'}}
        >
          {loading && <div className='px-3 py-2 text-muted'>Chargement...</div>}

          {!loading && filteredClients.length === 0 && (
            <div className='px-3 py-2 text-danger'>Aucun résultat trouvé</div>
          )}

          {!loading &&
            filteredClients.map((client) => (
              <div
                key={client[0].id}
                className='px-3 py-2 search-result-item cursor-pointer hover-bg-light'
                style={{cursor: 'pointer'}}
                onClick={() => handleSelect(client[0])}
              >
                <strong>{client[0].nom}</strong> {client[0].prenom}{' '}
                {client[0].nomSociete && (
                  <span className='text-muted'>({client[0].nomSociete})</span>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  )
}

export default SearchClient
